<template>
    <table class="table table-hover">
        <thead>
        <tr>
            <th>{{ $t('components.payout.amount') }}</th>
            <th>{{ $t('common.state') }}</th>
            <th>{{ $t('components.payout.created_date') }}</th>
            <th>{{ $t('components.payout.arrival_date') }}</th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <PayoutRow
            :payout="payout"
            v-for="payout in payouts"
            v-bind:key="payout.id"
        ></PayoutRow>
        </tbody>
    </table>
</template>

<script>

import PayoutRow from "./PayoutRow";

export default {
    name: "PayoutsTable",
    components: {PayoutRow},
    props: {
        payouts: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>

</style>